import { getWeeksInMonth } from '@internationalized/date';
import { useMemo } from 'react';
import { useCalendarGrid } from 'react-aria';
import type { CalendarState } from 'react-stately';
import { spacing } from '../../../../styles/spacing.css';
import { Layout } from '../../../Layout/Layout';
import * as styles from './CalendarViews.css';
import { Day } from './Day';
import { WeekDaysLabels } from './WeekDaysLabels';

const REPEATED_PADDING = `${spacing.s08} `.repeat(3);

interface DaysProps {
  readonly state: CalendarState;
  readonly locale: string;
}

export const Days: React.FC<DaysProps> = ({ state, locale, ...props }) => {
  const { gridProps, headerProps, weekDays } = useCalendarGrid({ ...props, weekdayStyle: 'short' }, state);

  const weeksInMonth = useMemo(
    () => getWeeksInMonth(state.visibleRange.start, locale),
    [locale, state.visibleRange.start],
  );

  return (
    <Layout as="div" {...gridProps} aria-label="days" padding={{ sm: 0, md: `0 ${REPEATED_PADDING}` }} role="grid">
      <Layout as="table" className={styles.table}>
        <thead {...headerProps}>
          <WeekDaysLabels weekDays={weekDays} />
        </thead>
        <tbody>
          {Array.from({ length: weeksInMonth }, (_, weekIndex) => (
            <tr key={weekIndex}>
              {state
                .getDatesInWeek(weekIndex)
                .map(date => date && <Day date={date} key={date.toString()} state={state} />)}
            </tr>
          ))}
        </tbody>
      </Layout>
    </Layout>
  );
};
